export enum EnvName {
  DEV = 1,
  STAGE,
  PROD,
}

/**
 * Environment configuration model
 */
export interface EnvironmentModel {
  /**
   * Application short name
   */
  shortName: string;
  /**
   * If this floating-button runs in production mode
   */
  production: boolean;

  /**
   * If you set this option, api methods will return mock data without requests on api server
   */
  useMocks: boolean;

  /**
   * Display name of the environment. Useful for debugging.
   */
  envName: EnvName;

  /**
   * Hostname of the backend server
   */
  apiHost: string;

  /**
   * Hostname of websocket server
   */
  wssHost: string;

  /**
   * Hostname of LMS server
   */
  lmsHost: string;

  /**
   * Url of webcomponent assets
   */
  assetsUrl: string;

  /**
   * Link to finance confluence
   */
  financeConfluenceLink: string;

  /**
   * Slack team messageId
   */
  slackTeamId: string;

  /**
   * If you set this option, ai chat will be blocked
   */
  blockAiChat: boolean;
}
